import { render } from "./videosCardHome.vue?vue&type=template&id=66454fa9"
import script from "./videosCardHome.vue?vue&type=script&lang=js"
export * from "./videosCardHome.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__